module.exports = __webpack_public_path__ + "img/icon-camera.ec6b4799.png";